package com.pointlessapps.granite.mica.llvm

import com.pointlessapps.granite.mica.ast.Root
import com.pointlessapps.granite.mica.ast.statements.FunctionDeclarationStatement
import com.pointlessapps.granite.mica.ast.statements.TypeDeclarationStatement

object LlvmCompiler {
    fun compile(root: Root): String {
        val context = LlvmCompilerContext()
        val builder = StringBuilder()

        // Preamble
        builder.append("; ModuleID = 'Mica'\n")
        builder.append("source_filename = \"Mica\"\n\n")

        // External declarations
        builder.append("declare i32 @printf(ptr, ...)\n")
        builder.append("declare i32 @scanf(ptr, ...)\n")
        builder.append("declare ptr @malloc(i64)\n")
        builder.append("declare void @free(ptr)\n")
        builder.append("declare i32 @sprintf(ptr, ptr, ...)\n")
        builder.append("@.str.int = private unnamed_addr constant [5 x i8] c\"%ld\\0A\\00\"\n")
        builder.append("@.str.double = private unnamed_addr constant [4 x i8] c\"%f\\0A\\00\"\n")
        builder.append("@.str.true = private unnamed_addr constant [6 x i8] c\"true\\0A\\00\"\n")
        builder.append("@.str.false = private unnamed_addr constant [7 x i8] c\"false\\0A\\00\"\n")
        builder.append("@.str.string = private unnamed_addr constant [4 x i8] c\"%s\\0A\\00\"\n")
        builder.append("@.str.int_fmt = private unnamed_addr constant [4 x i8] c\"%ld\\00\"\n")
        builder.append("@.str.double_fmt = private unnamed_addr constant [3 x i8] c\"%f\\00\"\n")
        builder.append("@.str.string_fmt = private unnamed_addr constant [3 x i8] c\"%s\\00\"\n\n")

        val functionBuilder = StringBuilder()
        val mainBuilder = StringBuilder()

        // Define standard structs
        builder.append("%Array = type { i64, ptr }\n")
        builder.append("%Set = type { i64, ptr }\n")
        builder.append("%Map = type { i64, ptr, ptr }\n")
        
        // Pre-scan for types and functions
        for (statement in root.statements) {
            if (statement is TypeDeclarationStatement) {
                // PoC: all properties are i64
                val structTypes = statement.properties.joinToString(", ") { "i64" }
                builder.append("%${statement.nameToken.value} = type { $structTypes }\n")
                context.declareStruct(statement.nameToken.value, statement.properties.map { it.nameToken.value })
            } else if (statement is FunctionDeclarationStatement) {
                val hasVararg = statement.parameters.any { it.varargToken != null }
                context.declareFunction(statement.nameToken.value, statement.parameters.size, hasVararg)
            }
        }

        for (statement in root.statements) {
            if (statement is FunctionDeclarationStatement) {
                statement.compile(context, functionBuilder)
            } else if (statement !is TypeDeclarationStatement) {
                statement.compile(context, mainBuilder)
            }
        }

        // Append string constants to the main builder's preamble (or right after)
        context.stringConstants.forEach { (value, name) ->
            // Unescape or just format the string. For PoC we assume simple ASCII strings
            val len = value.length + 1
            builder.append("$name = private unnamed_addr constant [$len x i8] c\"$value\\00\"\n")
        }

        builder.append(functionBuilder)

        // Top level statements are wrapped in a main function for LLVM
        builder.append("define i32 @main() {\n")
        builder.append("entry:\n")
        builder.append(mainBuilder)
        val lastLineMain = mainBuilder.toString().trimEnd().substringAfterLast('\n').trim()
        if (!lastLineMain.startsWith("ret ")) {
            builder.append("  ret i32 0\n")
        }
        builder.append("}\n")

        return builder.toString()
    }
}
